import { domains } from './domains';

export const doA11yValidation = (v, field, formValidationSent) => {
  const error = doValidateField(field, v);
  if (JSON.stringify(field.validations) !== '{}') {
    if ((v?.length >= 1 || formValidationSent) && error?.fieldId === field.id) return 'true'
    else if (v?.length >= 1) return 'false'
    else return ''
  }
}

export const doValidateField = (field, value) => {
  const isRequired = field.validations && field.validations.required;
  const minLength = field.validations && field.validations.minLength;
  const maxLength = field.validations && field.validations.maxLength;
  const hasRegex = field?.validations?.regex?.pattern ? true : false;
  const integer = field.dataType === 'integer';
  const decimal = field.dataType === 'decimal';
  const isBusinessEmail = field.id === 'businessEmail';

  if (isRequired && value?.length <= 0) {
    const errorMessage = isRequired?.message?.['en-GB'] || `${field.name?.['en-GB']} is required`;
    return { fieldId: field.id, groupId: field.groupId, message: errorMessage };
  }
  if (minLength && minLength.value > value.length) {
    const errorMessage = minLength.message
      ? minLength.message['en-GB']
      : `Minimum characters ${minLength.value}`;
    return { fieldId: field.id, groupId: field.groupId, message: errorMessage };
  }
  if (maxLength && maxLength.value < value.length) {
    const errorMessage =
      maxLength.message && maxLength.message['en-GB']
        ? maxLength.message['en-GB']
        : `Maximum characters ${maxLength.value}`;
    return { fieldId: field.id, groupId: field.groupId, message: errorMessage };
  }
  /** Check Regex and Business Emails */
  if (hasRegex && value.length >= 1) {
    const r = field.validations.regex;
    const msg = r?.message?.['en-GB'] || `${field.name['en-GB']} is invalid`;
    if (isValidRegex(field, value) && isBusinessEmail) {
      if (!isBusinessEmailValid(field, value)) {
        return {
          fieldId: field.id,
          groupId: field.groupId,
          message: 'You must enter a business email address.',
        };
      }
    } else if (!isValidRegex(field, value)) {
      return {
        fieldId: field.id,
        groupId: field.groupId,
        message: msg,
      };
    }
  }
  if (integer) {
    const isInteger = value % 1 === 0;
    if (!isInteger) {
      const errorMessage = `${value} is not an ${field.dataType}`;
      return {
        fieldId: field.id,
        groupId: field.groupId,
        message: errorMessage,
      };
    }
  }
  if (decimal) {
    const isDecimal = value % 1 !== 0;
    if (!isDecimal) {
      const errorMessage = `${value} is not an ${field.dataType}`;
      return {
        fieldId: field.id,
        groupId: field.groupId,
        message: errorMessage,
      };
    }
  }
};

const isValidRegex = (field, value) => {
  const regexPattern = field?.validations?.regex?.pattern;
  if (!regexPattern || regexPattern === '') return false;

  try {
    // Create RegExp object from string pattern
    const regexObject = new RegExp(regexPattern.replace(/^\/|\/$/g, '')); 
    // Check the value being tested
    const result = regexObject.test(value);
    return result;
  } catch (err) {
    return false;
  }
};

const isBusinessEmailValid = (field, value) => {
  const domain = value.split('@').pop();
  if (!domains.includes(domain)) return true;
  else return false;
};
